var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCheckboxCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.82101 4.35728C0.749581 4.28585 0.713867 4.17871 0.713867 4.10728C0.713867 4.03585 0.749581 3.92871 0.82101 3.85728L1.32101 3.35728C1.46387 3.21443 1.67815 3.21443 1.82101 3.35728L1.85672 3.393L3.82101 5.50014C3.89244 5.57157 3.99958 5.57157 4.07101 5.50014L8.85672 0.535854H8.89244C9.0353 0.392997 9.24958 0.392997 9.39244 0.535854L9.89244 1.03585C10.0353 1.17871 10.0353 1.393 9.89244 1.53585L4.17815 7.46443C4.10672 7.53585 4.0353 7.57157 3.92815 7.57157C3.82101 7.57157 3.74958 7.53585 3.67815 7.46443L0.892439 4.46443L0.82101 4.35728Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxCheckmark);
export default __webpack_public_path__ + "static/media/ic_checkbox_checkmark.5db3612fed0f42543768099728d3070b.svg";
export { ForwardRef as ReactComponent };